export default __webpack_public_path__ + "static/media/familyandfriends_8.4afc74b5.png";